<template>
  <el-container class="box-card">
    <el-header>
      <span>{{ $t('route.cuadrillaedit') }}</span>
    </el-header>
    <el-main>
      <el-form style="display: flex;">
        <el-form-item
          :label="$t('cuadrilla.description')"
          style="margin: auto; margin-right: 10px;"
        >
          <el-input
            name="descripcion"
            v-model="cuadrilla.cuad_descripcion"
            v-validate="'required'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Placa vehiculo"
          style="margin: auto; margin-right: 10px;"
        >
          <el-input
            name="placa_vehiculo"
            v-model="cuadrilla.cuad_vehiculo"
            v-validate="'required'"
          ></el-input>
        </el-form-item>
        <el-form-item label="Estado" style="margin: auto; margin-right: 10px;">
          <el-select
            name="estado"
            v-model="cuadrilla.cuad_estado"
            v-validate="'required'"
          >
            <el-option
              v-for="item in options_cuad_estado"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="Contratista" style="margin: auto; margin-right: 10px;">
          <el-select
            name="contratista"
            v-model="cuadrilla.cont_id"
            v-validate="'required'"
          >
            <el-option
              v-for="item in options_contratista"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
      </el-form>
      <section style="padding-top: 50px;">
        <el-button
          :disabled="!validate()"
          size="medium"
          type="primary"
          icon="el-icon-check"
          @click="aplicar"
        ></el-button>
      </section>
    </el-main>
  </el-container>
</template>
<script>
  import { getCuadrilla, updateCuadrilla } from '@/api/cuadrilla'
  import { getContratistas } from '@/api/contratista'

  export default {
    data() {
      return {
        cuadrilla: {
          cuad_descripcion: '',
          cuad_estado: 1,
          cont_id: '',
          cuad_vehiculo: ''
        },
        options_contratista: [],
        options_cuad_estado: [
          { value: 1, label: 'Activo' },
          { value: 0, label: 'Inactivo' }
        ],
        message: '',
        loading: false,
        page_size: 10,
        current_page: 1
      }
    },
    methods: {
      aplicar() {
        updateCuadrilla(this.cuadrilla)
          .then(response => {
            if (response.status === 200) {
              this.success()
            }
          })
          .catch(error => {
            this.error(error)
          })
      },
      validate() {
        if (this.cuadrilla.cuad_descripcion) {
          return true
        } else {
          return false
        }
      },
      limpiarAndBack() {
        this.limpiar()
        this.$router.push({ path: '/administracion/cuadrilla' })
      },
      limpiar() {
        this.cuadrilla = {
          cuad_descripcion: '',
          cuad_estado: 1
        }
      },
      success() {
        this.$notify({
          title: this.$i18n.t('cuadrilla.success'),
          message:
            this.$i18n.t('cuadrilla.updated') +
            ' ' +
            this.cuadrilla.cuad_descripcion,
          type: 'success',
          onClose: this.limpiarAndBack()
        })
      },
      error(e) {
        this.$notify.error({
          title: this.$i18n.t('cuadrilla.error'),
          message: this.$i18n.t('cuadrilla.notupdated') + ' ' + e,
          onClose: this.limpiar()
        })
      }
    },
    mounted() {
      getCuadrilla(this.$route.params.id)
        .then(response => {
          this.cuadrilla = response.data
          getContratistas()
          .then(response => {
            response.data.forEach(element => {
              this.options_contratista.push({
                value: element.cont_id,
                label: element.cont_nombre
              })
            })
            console.log('contratista', response.data)
          })
          .catch((error) => {
            console.log('error1', error)
          })
        })
        .catch(() => {
          console.log('error2')
        })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    width: 100%;
  }
  .footfont {
    font-size: 11px;
  }
</style>
